import { useEffect, useState } from "react"

export function useIsNativeApp() {
  const [isNativeApp, setIsNativeApp] = useState(false)

  useEffect(() => {
    const native =
      !!window.webkit?.messageHandlers?.mixtape

    setIsNativeApp(native)
  }, [])

  return isNativeApp
}